// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__N6gis","rootMobile":"styles_rootMobile__1WxBo"};